import { Flex, Box } from 'reflexbox/styled-components';

import Section from '@/components/section';
import Title from '@/components/title';
import PostExcerpt from '@/components/blog/post-excerpt';

const Posts = ({ posts }) => {
  return (
    <Section>
      <Title>Recent Posts</Title>
      <Flex flexWrap="wrap" mb="-2em" mx="-1em">
        {posts.map(post => (
          <Box key={post.slug} mb="2em" px="1em" width={[1, 1/2]}>
            <PostExcerpt
              author={post.author}
              date={post.date}
              description={post.description}
              slug={post.slug}
              title={post.title} />
          </Box>
        ))}
      </Flex>
    </Section>
  );
};

export default Posts;
